import axios from 'axios'
import md5 from 'js-md5'
import store from 'storejs'
import $store from '../store'
import { MessageBox } from "element-ui";
import { decodeURLParams } from './utils';

let { token, userid } = decodeURLParams();

const en = {
    text: 'Your account logged in somewhere else, Please log in again.',
    tips: 'warning',
    signin: 'Sign in',
    cancel: 'Cancel'
}
const cn = {
    text: '您的帐号在其他地方登录了，请重新登录',
    tips: '提示',
    signin: '登录',
    cancel: '取消'
}
let lang = store('lang') || 'en-us';

//兼容测试方案，动态切换
axios.defaults.baseURL = sessionStorage.getItem("beta.url") || process.env.API;

axios.interceptors.response.use(function (config) {
    if (config.data.code == 'E_7000') {
        /* 帐号在其它地方登录 */
        // router.push('/')
        $store.dispatch('updateToken', null);
        MessageBox.confirm(lang === 'zh-CN' ? cn.text : en.text, lang === 'zh-CN' ? cn.tips : en.tips, {
            confirmButtonText: lang === 'zh-CN' ? cn.signin : en.signin,
            cancelButtonText: lang === 'zh-CN' ? cn.cancel : en.cancel,
            type: 'warning'
        }).then(() => {
            $store.dispatch('toggleShowLogin', true);
        }).catch(() => {

        })
    }
    return config;
}, function (error) {
    return Promise.reject(error);
})

export default class Requests {
    static sort(arys) {
        let newkey = Object.keys(arys).sort();
        let newObj = {};
        for (let i = 0; i < newkey.length; i++) {
            newObj[newkey[i]] = arys[newkey[i]];
        }
        return newObj;
    }

    static arysToString(arys, token = null) {
        const digit = 1 * Math.pow(10, 15);
        arys.random = Math.ceil(Math.random() * digit);
        let reqBody = Object.create(null);
        Object.assign(reqBody, arys);
        if (token !== null) {
            reqBody.token = token;
        }
        let str = '';
        Object.keys(Requests.sort(reqBody)).forEach(function (key) {
            str += `${key}=${reqBody[key]}&`
        });
        str = str.substr(0, str.length - 1);
        return str
    }

    static sign(arys, token = null) {
        let s = Requests.arysToString(arys, token);
        const key = process.env.KEY;
        return md5(md5(s + key) + key)
    }

    static init() {
        // "user-id": 123
        // "user-token": "971b77f8bb0b6f89727352fcde45b062"
        // "client": "android / ios / web"
        // "client-lang": "en-us"

        let lang = store('lang') || 'zh-hk';
        let user = store('user') || null;

        axios.defaults.headers.common["client"] = 'web';
        axios.defaults.headers.common["client-lang"] = lang.toLowerCase();
        if (user) {
            axios.defaults.headers.common["user-id"] = userid || user['user_id']
        } else {
            /* 适应待支付情况 */
            axios.defaults.headers.common["user-id"] = userid
        }
        if (user) {
            axios.defaults.headers.common["user-token"] = token || store('user_token');
            return store('user_token');
        } else {
            axios.defaults.headers.common["user-token"] = token
        }
        return null;
    }

    static get(uri, params = {}) {
        let token = Requests.init();
        params.sign = Requests.sign(params, token);
        return axios.get(uri, {
            params: params
        })
    }

    static post(uri, params = {}) {
        let token = Requests.init();
        params.sign = Requests.sign(params, token);
        return axios.post(uri, params);
    }
}



// WEBPACK FOOTER //
// ./src/lib/requests.js